import React from 'react'
import { AUTH_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
  {
    key: 'login',
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() => import('views/auth-views/authentication/login')),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: 'partner',
    path: `${AUTH_PREFIX_PATH}/partner`,
    component: React.lazy(() => import('views/auth-views/authentication/partner')),
    meta: {
      blankLayout: false,
    },
  },
  {
    key: 'login-1',
    path: `${AUTH_PREFIX_PATH}/login-1`,
    component: React.lazy(() => import('views/auth-views/authentication/login-1')),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: 'login-2',
    path: `${AUTH_PREFIX_PATH}/login-2`,
    component: React.lazy(() => import('views/auth-views/authentication/login-2')),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: 'register-1',
    path: `${AUTH_PREFIX_PATH}/register-1`,
    component: React.lazy(() => import('views/auth-views/authentication/register-1')),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: 'register-2',
    path: `${AUTH_PREFIX_PATH}/register-2`,
    component: React.lazy(() => import('views/auth-views/authentication/register-2')),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: 'password-change',
    path: `${AUTH_PREFIX_PATH}/password-change`,
    component: React.lazy(() => import('views/auth-views/authentication/password-change')),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: 'error-page-1',
    path: `${AUTH_PREFIX_PATH}/error-page-1`,
    component: React.lazy(() => import('views/auth-views/errors/error-page-1')),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: 'error-page-2',
    path: `${AUTH_PREFIX_PATH}/error-page-2`,
    component: React.lazy(() => import('views/auth-views/errors/error-page-2')),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: 'public-erp',
    path: 'erp',
    component: React.lazy(() => import('views/app-views/shared/erp')),
    meta: {
      blankLayout: true,
    },
  },
]

export const protectedRoutes = [
  // {
  //   key: 'public-erp',
  //   path: 'erp',
  //   component: React.lazy(() => import('views/app-views/shared/erp')),
  //   meta: {
  //     blankLayout: true,
  //   },
  // },
  // {
  //   key: 'home',
  //   path: `${APP_PREFIX_PATH}/home`,
  //   component: React.lazy(() => import('views/app-views/home')),
  //   meta: {
  //     blankLayout: true,
  //   },
  // },
]
